import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { isButtonEnabled } from 'src/components/design-system/Button';
import { errorIcon } from 'src/utils/icons';

const InfoCell: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const { quantityReceived, glCd } = dataItem;
  const showErrorIcon =
    (typeof quantityReceived == 'string' && quantityReceived.length === 0) || glCd?.length === 0;

  return (
    <GridCellBase
      {...props}
      className={
        isButtonEnabled(dataItem?.canDelete) && showErrorIcon ? 'bg-error bg-opacity-25' : ''
      }
    >
      {isButtonEnabled(dataItem?.canDelete) || dataItem?.isNewLineItem ? (
        <div className="w-full flex justify-center items-center">{showErrorIcon && errorIcon}</div>
      ) : (
        <span className="font-bold text-sm">Org</span>
      )}
    </GridCellBase>
  );
};

export default InfoCell;
